import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-[1000] flex items-start justify-center bg-black/30 overflow-auto p-6"
};
const _hoisted_2 = {
  class: "w-full max-w-[68rem] bg-white rounded-lg shadow-2xl border border-gray-200 relative text-gray-800 tw flex flex-col"
};
const _hoisted_3 = {
  class: "py-4 px-6"
};
const _hoisted_4 = {
  class: "flex items-start justify-between gap-4 flex-wrap"
};
const _hoisted_5 = {
  class: "flex-1 min-w-0"
};
const _hoisted_6 = {
  class: "text-2xl font-semibold mb-1"
};
const _hoisted_7 = {
  class: "text-sm text-gray-600 max-w-2xl"
};
const _hoisted_8 = {
  class: "px-6 py-2"
};
const _hoisted_9 = {
  key: 0,
  class: "text-center py-8"
};
const _hoisted_10 = {
  class: "px-6 flex flex-col gap-4"
};
const _hoisted_11 = {
  key: 0,
  class: "bg-white-50 p-4 rounded-lg"
};
const _hoisted_12 = {
  class: "flex flex-col md:flex-row md:items-start md:justify-between gap-6"
};
const _hoisted_13 = {
  class: "flex items-start gap-2"
};
const _hoisted_14 = {
  key: 0,
  class: "w-4/12 md:w-auto md:text-right"
};
const _hoisted_15 = {
  class: "text-3xl font-bold text-green"
};
const _hoisted_16 = {
  class: "text-base font-normal text-gray-600"
};
const _hoisted_17 = {
  class: "text-sm text-gray-600"
};
const _hoisted_18 = {
  key: 1,
  class: "h-24 mt-2"
};
const _hoisted_19 = {
  key: 2,
  class: "-mt-2"
};
const _hoisted_20 = {
  class: "w-full rounded-md border border-green-500/40 bg-green-50 text-green-800 text-sm px-5 py-2 leading-snug"
};
const _hoisted_21 = {
  class: "flex flex-col md:flex-row md:items-center md:justify-between gap-4 pb-4"
};
const _hoisted_22 = {
  class: "text-base text-gray-600 flex items-start gap-1"
};
const _hoisted_23 = {
  class: "flex gap-3 justify-end"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 1,
  class: "flex items-center gap-1"
};
import { ref, computed, onMounted, watch } from 'vue';
import PlanCard from './PlanCard.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import { useMaxioSubscriptionStore } from '../../settings/subscription/MaxioSubbscription/useMaxioSubscriptionStore.js';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { isValidSingleEmail, formatCurrency } from '@/services/utils.js';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'PlanSelection',
  emits: ['cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      subscription
    } = storeToRefs(useCompanyStore());
    const emit = __emit;

    // Track billing period per plan to keep Core/Pro independent
    const planBillingPeriods = ref({}); // { [planId]: 'monthly' | 'annually' }
    const selectedBillingPeriod = computed(() => planBillingPeriods.value[selectedPlan.value] || 'monthly');
    const selectedPlan = ref('core');
    const processing = ref(false);
    const dataLoading = ref(true);
    const expandedDetails = ref(null); // plan id of open details

    // Form fields
    const seats = ref(1);
    const couponCode = ref('');
    const billingEmail = ref('');
    const validatedCoupon = ref(null);
    const lastValidatedCode = ref('');

    // Email validation using shared utils
    const validBillingEmail = computed(() => {
      const email = (billingEmail.value || '').trim();
      if (!email) return true; // optional here; API enforces if required
      return isValidSingleEmail(email);
    });

    // Initialize the subscription store
    const maxioSubscriptionStore = useMaxioSubscriptionStore();
    const companyStore = useCompanyStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);

    // Fetch subscription data on component mount
    onMounted(async () => {
      try {
        await Promise.all([maxioSubscriptionStore.listSubscriptionProducts(), maxioSubscriptionStore.getSubscription(), companyStore.loadMyCompany()]);
      } catch (error) {
        console.error('Error fetching subscription data:', error);
      } finally {
        dataLoading.value = false;
      }
    });
    function getDaysRemaining(endDate) {
      try {
        if (!endDate) return null;
        const now = Date.now();
        const end = new Date(endDate).getTime();
        if (Number.isNaN(end)) return null;
        const diff = end - now;
        if (diff <= 0) return 0; // expired
        const day = 24 * 60 * 60 * 1000;
        return Math.ceil(diff / day);
      } catch (e) {
        return null;
      }
    }
    const daysRemaining = computed(() => {
      const sub = subscription.value || {};
      // Prefer explicit trialEndDate; fallback to trialEndDays numeric if present
      const fromDate = getDaysRemaining(sub.trialEndDate);
      if (fromDate !== null) return fromDate;

      // Only use trialEndDays if it's not null/undefined and is a valid number
      if (sub.trialEndDays != null) {
        const d = Number(sub.trialEndDays);
        return Number.isFinite(d) ? d : null;
      }
      return null;
    });
    const headingText = computed(() => {
      const sub = subscription.value || {};
      if (sub.inactive || sub.trialExpired || daysRemaining.value === 0) {
        return 'Your trial has ended';
      }
      if (sub.trial) {
        if (daysRemaining.value != null) {
          if (daysRemaining.value > 7) {
            return "You're in trial – plan ahead";
          }
          // 1-7 days (or under a day but positive) => ending soon
          return 'Trial ending soon – pick your plan';
        }
        // Unknown remaining time but still flagged as trial
        return "You're in trial – plan ahead";
      }
      // Non-trial context fallback
      return 'Pick your plan';
    });
    const subheadingText = computed(() => {
      const sub = subscription.value || {};
      if (sub.inactive || sub.trialExpired || daysRemaining.value === 0) {
        return 'The trial period is over. Choose a subscription to resume access.';
      }
      if (sub.trial) {
        if (daysRemaining.value != null) {
          if (daysRemaining.value > 7) {
            return 'Your trial is still active. Pick a plan now so your workflow continues without disruption.';
          }
          return 'Your trial is almost over. Activate a plan now to avoid interruption.';
        }
        return 'Your trial is still active. Pick a plan now so your workflow continues without disruption.';
      }
      return 'Choose the plan that fits your needs.';
    });
    async function applyCoupon() {
      if (!couponCode.value) return;
      try {
        const selectedPlanData = plans.value.find(p => p.id === selectedPlan.value);
        const productId = selectedBillingPeriod.value === 'monthly' ? selectedPlanData?.monthlyProductId : selectedPlanData?.yearlyProductId;
        if (!productId) {
          throw new Error('Product not found for selected plan/period');
        }
        const result = await maxioSubscriptionStore.verifyCoupon(productId, couponCode.value);
        // Persist the response (id, label, description) if provided by API
        validatedCoupon.value = result || null;
        lastValidatedCode.value = couponCode.value;
        handleSuccess('Coupon verified');
      } catch (e) {
        // On failure, clear the coupon and reset validation state
        couponCode.value = '';
        lastValidatedCode.value = '';
        validatedCoupon.value = null;
        handleError(e);
      }
    }
    const minSeatsRequired = computed(() => {
      // fallback to 1 if not set
      return Number(maxioSubscriptionStore.subscription?.seatsRequired) || 1;
    });

    // Get number of seats from subscription data
    const numberOfSeats = computed(() => seats.value || 1);

    // Initialize seats/email from subscription when available
    watch(() => maxioSubscriptionStore.subscription, sub => {
      const initialSeats = sub?.seatsRequired || sub?.plan?.currentPaidSeats || sub?.plan?.seats || 1;
      if (!seats.value || seats.value === 1) seats.value = initialSeats;
      if (!billingEmail.value) billingEmail.value = sub?.billingEmail || sub?.email || meStore?.me?.email || '';
    }, {
      immediate: true
    });

    // Reset coupon validation if user edits coupon code
    watch(() => couponCode.value, () => {
      if (couponCode.value !== lastValidatedCode.value) {
        validatedCoupon.value = null;
      }
    });

    // Map the real API data to the local plan structure
    const plans = computed(() => {
      const products = maxioSubscriptionStore.subscriptionProducts;
      if (!products?.productFamilies) {
        // Return default plans if API data not loaded yet
        return getDefaultPlans();
      }

      // Map API data to local plan structure
      const planMap = [];
      products.productFamilies.forEach(family => {
        const planId = family.leanlawProductId?.replace('leanlaw-', '') || (family.label.toLowerCase().includes('core') ? 'core' : 'pro');
        const monthlyProduct = family.products?.find(p => p.interval === 'monthly');
        const yearlyProduct = family.products?.find(p => p.interval === 'yearly');
        planMap.push({
          id: planId,
          name: family.label.replace('LeanLaw ', ''),
          tagline: family.tagline || getDefaultPlans().find(p => p.id === planId)?.tagline,
          monthlyPrice: monthlyProduct?.price || null,
          annualPrice: yearlyProduct?.price || null,
          monthlyProductId: monthlyProduct?.id,
          yearlyProductId: yearlyProduct?.id,
          annualSavePercent: monthlyProduct && yearlyProduct ? Math.round((monthlyProduct.price * 12 - yearlyProduct.price * 12) / (monthlyProduct.price * 12) * 100) : 12,
          features: family.features || getFeatures(planId),
          ctaType: 'select'
        });
      });
      planMap.push(getDefaultPlans().find(p => p.id === 'elite'));
      return planMap;
    });

    // Calculate total amount for selected plan
    const totalAmount = computed(() => {
      const selectedPlanData = plans.value.find(p => p.id === selectedPlan.value);
      if (!selectedPlanData) return 0;
      const price = selectedBillingPeriod.value === 'monthly' ? selectedPlanData.monthlyPrice : selectedPlanData.annualPrice;
      const months = selectedBillingPeriod.value === 'annually' ? 12 : 1;
      return numberOfSeats.value * months * (price || 0);
    });

    // Footer helpers
    const totalSuffix = computed(() => selectedBillingPeriod.value === 'annually' ? 'per year' : 'per month');
    const seatsBreakdown = computed(() => {
      const selectedPlanData = plans.value.find(p => p.id === selectedPlan.value);
      if (!selectedPlanData) return '';
      const unitPrice = selectedBillingPeriod.value === 'monthly' ? selectedPlanData.monthlyPrice : selectedPlanData.annualPrice;
      const months = selectedBillingPeriod.value === 'annually' ? ' × 12 month' : '';
      const seats = numberOfSeats.value;
      return `${seats} seat${seats === 1 ? '' : 's'}${months} × $${unitPrice || 0} per seat`;
    });

    // Gate for enabling Continue button
    const canContinue = computed(() => {
      const basicReady = !!selectedPlan.value && !processing.value && !dataLoading.value && validBillingEmail.value && Number(seats.value) >= minSeatsRequired.value;
      if (!basicReady) return false;
      // If no coupon entered, allow continue
      if (!couponCode.value) return true;
      // Require successful validation for the current code
      return validatedCoupon.value !== null && couponCode.value === lastValidatedCode.value;
    });

    // Helper functions
    function getDefaultPlans() {
      return [{
        id: 'core',
        name: 'Core',
        tagline: "Streamline billing and boost productivity with LeanLaw's Standard plan.",
        monthlyPrice: 45,
        annualPrice: 40,
        annualSavePercent: 12,
        features: getFeatures('core'),
        ctaType: 'select'
      }, {
        id: 'pro',
        name: 'Pro',
        tagline: 'Enhance your client experience with advanced custom billing using LeanLaw Pro.',
        monthlyPrice: 70,
        annualPrice: 60,
        annualSavePercent: 14,
        features: getFeatures('pro'),
        ctaType: 'select'
      }, {
        id: 'elite',
        name: 'Elite',
        tagline: 'Achieve best-in-class performance with LeanLaw Elite - the ultimate billing solution for top-tier law firms.',
        monthlyPrice: null,
        annualPrice: null,
        features: ['Everything in Pro, plus these add-ons:', 'Customize your billing with unlimited invoice templates tailored to your firm.', 'Maximize the value of LeanLaw for your practice with priority support & a dedicated support manage.', 'Grow your firm with custom reporting on productivity utilization, realization, collection, overhead, and profit.', 'Save hours on payroll and retain top talent with compensation tracking.'],
        ctaType: 'contact'
      }];
    }
    function getFeatures(planId) {
      switch (planId) {
        case 'core':
          return ['Time tracking tools that help lawyers capture every billable minute, visualize their day, and maximize profitability.', 'Get paid faster and improve your collection with E-Payments.', "Make better business decisions with LeanLaw's reporting dashboard.", 'Save hours on reconciliation with accurate trust accounting.', 'Generate professional invoices to clients with a single click.', 'Two-way sync with Quickbooks that ensures data fidelity, saving you time and headaches.'];
        case 'pro':
          return ['Everything in Core, plus:', 'Save time billing clients using three custom invoice templates.', 'Reduce administrative overhead and speed up the payment process with ready-to-upload LEDES files.', 'Improve workflow efficiency with precise user permissions.', 'Manage finances easily using matter-based accounting that organizes transactions by client or case.'];
        default:
          return [];
      }
    }
    function onSelect(id) {
      if (expandedDetails.value && expandedDetails.value !== id) {
        expandedDetails.value = null;
      }
      selectedPlan.value = id;
    }
    function onToggleDetails(planId) {
      const isOpening = expandedDetails.value !== planId;
      expandedDetails.value = isOpening ? planId : null;
      if (isOpening) {
        selectedPlan.value = planId;
      }
    }
    function appendLabelParam(url) {
      const label = 'Start Subscription';
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('label', label);
        return u.toString();
      } catch (e) {
        const sep = url && url.indexOf('?') !== -1 ? '&' : '?';
        return `${url}${sep}label=${encodeURIComponent(label)}`;
      }
    }
    function onPlanContinue(startSubscription = false) {
      // Redirect to self-service payment portal if available
      const url = maxioSubscriptionStore?.subscription?.selfServicePaymentUrl;
      window.location.href = startSubscription ? appendLabelParam(url) : url;
      // Close overlay in parent
      emit('cancel');
    }
    async function continueFlow() {
      processing.value = true;
      try {
        const selectedPlanData = plans.value.find(p => p.id === selectedPlan.value);
        const productId = selectedBillingPeriod.value === 'monthly' ? selectedPlanData?.monthlyProductId : selectedPlanData?.yearlyProductId;
        if (!maxioSubscriptionStore?.subscription?.product) {
          try {
            await maxioSubscriptionStore.createSubscriptionComponent({
              productId,
              seats: numberOfSeats.value,
              coupon: couponCode.value || '',
              email: billingEmail.value || ''
            });
            onPlanContinue(true);
          } catch (error) {
            handleError(error);
          }
        } else {
          await maxioSubscriptionStore.updateSubscriptions({
            productId
          });
          onPlanContinue(false);
        }
      } finally {
        processing.value = false;
      }
    }

    // Helpers for plan-specific period
    function billingPeriodFor(id) {
      return planBillingPeriods.value[id] || 'monthly';
    }
    function onChangePeriod(planId, period) {
      planBillingPeriods.value = {
        ...planBillingPeriods.value,
        [planId]: period
      };
      // When user switches period on a card, make that plan the selected one
      selectedPlan.value = planId;
    }
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h1", _hoisted_6, _toDisplayString(headingText.value), 1), _createElementVNode("p", _hoisted_7, [_createTextVNode(_toDisplayString(subheadingText.value) + " ", 1), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _cache[6] || (_cache[6] = _createTextVNode(" Questions? Our support team is here to help, get in touch at ", -1)), _cache[7] || (_cache[7] = _createElementVNode("a", {
        href: "mailto:support@myleanlaw.com",
        class: "hover:underline"
      }, "support@myleanlaw.com", -1)), _cache[8] || (_cache[8] = _createTextVNode(". ", -1))]), _cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "text-sm font-medium mt-2"
      }, " Choose the plan that fits your firm ", -1))]), _createVNode(LlSecondaryButton, {
        class: "shrink-0",
        variant: "text",
        icon: "mdi-close",
        ripple: false,
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = $event => emit('cancel'))
      })])]), _createElementVNode("div", _hoisted_8, [dataLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
        class: "animate-spin h-8 w-8 border-4 border-[rgb(var(--v-theme-success))] border-t-transparent rounded-full mx-auto mb-4"
      }, null, -1), _createElementVNode("div", {
        class: "text-gray-600"
      }, "Loading subscription plans...", -1)]))])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["grid gap-6 md:grid-cols-3", expandedDetails.value ? 'items-start' : 'items-stretch'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, p => {
        return _openBlock(), _createBlock(PlanCard, {
          key: p.id,
          plan: p,
          billingPeriod: billingPeriodFor(p.id),
          selected: selectedPlan.value === p.id,
          detailsOpen: expandedDetails.value === p.id,
          compact: expandedDetails.value && expandedDetails.value !== p.id,
          onSelect: $event => onSelect(p.id),
          onChangePeriod: $event => onChangePeriod(p.id, $event),
          onToggleDetails: onToggleDetails
        }, null, 8, ["plan", "billingPeriod", "selected", "detailsOpen", "compact", "onSelect", "onChangePeriod"]);
      }), 128))], 2))]), _createElementVNode("div", _hoisted_10, [!dataLoading.value && selectedPlan.value && selectedPlan.value !== 'elite' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: _normalizeClass([_unref(features)?.customPricing ? 'w-full' : 'w-8/12', "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"])
      }, [_createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "flex items-center justify-between mb-1"
      }, [_createElementVNode("label", {
        class: "text-sm"
      }, "Seats (Users)")], -1)), _createVNode(LlTextField, {
        label: "",
        type: "number",
        min: 1,
        step: 1,
        modelValue: seats.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => seats.value = $event),
        modelModifiers: {
          number: true
        },
        "hide-details": false,
        rules: [v => Number(v) >= minSeatsRequired.value || `Seats cannot be less than ${minSeatsRequired.value}`]
      }, null, 8, ["modelValue", "rules"])]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "flex items-center justify-between mb-1"
      }, [_createElementVNode("label", {
        class: "text-sm"
      }, "Coupon Code")], -1)), _createElementVNode("div", _hoisted_13, [_createVNode(LlTextField, {
        label: "",
        modelValue: couponCode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => couponCode.value = $event),
        modelModifiers: {
          trim: true
        },
        "hide-details": false,
        class: "flex-1"
      }, null, 8, ["modelValue"]), _createVNode(LlSecondaryButton, {
        class: "font-semibold disabled:text-gray-400 px-3 mt-1",
        variant: "text",
        color: "primary",
        size: "small",
        disabled: !couponCode.value,
        onClick: applyCoupon
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Validate ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "flex items-center justify-between mb-1"
      }, [_createElementVNode("label", {
        class: "text-sm"
      }, "Billing Email")], -1)), _createVNode(LlTextField, {
        label: "",
        type: "email",
        modelValue: billingEmail.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => billingEmail.value = $event),
        modelModifiers: {
          trim: true
        },
        "hide-details": false,
        rules: [v => !v || _unref(isValidSingleEmail)(v) || 'Please enter a valid email address.']
      }, null, 8, ["modelValue", "rules"])])], 2), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "text-sm font-medium text-gray-700"
      }, "Total Amount", -1)), _createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(_unref(formatCurrency)(totalAmount.value)) + " ", 1), _createElementVNode("span", _hoisted_16, _toDisplayString(totalSuffix.value), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(seatsBreakdown.value), 1)])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_18)), validatedCoupon.value?.description && couponCode.value === lastValidatedCode.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(validatedCoupon.value.description), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_v_icon, null, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("mdi-alert-circle-outline", -1)]))]),
        _: 1
      }), _cache[17] || (_cache[17] = _createElementVNode("span", null, "You won't be charged until your trial ends—cancel anytime with no hassle.", -1))]), _createElementVNode("div", _hoisted_23, [_createVNode(LlSecondaryButton, {
        disabled: processing.value || dataLoading.value,
        onBtnClick: _cache[4] || (_cache[4] = $event => emit('cancel'))
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        disabled: !canContinue.value,
        onBtnClick: continueFlow
      }, {
        default: _withCtx(() => [!processing.value ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Continue")) : (_openBlock(), _createElementBlock("span", _hoisted_25, [...(_cache[19] || (_cache[19] = [_createElementVNode("span", {
          class: "animate-spin h-4 w-4 border-2 border-current border-t-transparent rounded-full"
        }, null, -1), _createTextVNode(" Processing ", -1)]))]))]),
        _: 1
      }, 8, ["disabled"])])])])])]);
    };
  }
};